/**
 * Constants for Reviews module
 */

export const QUALITY_RATING_NAME = 'Calitate'

export const DEFAULT_PAGE_SIZE = 50

export const DEFAULT_CURRENT_PAGE = 1

export const REVIEW_LABELS = {
  reviews: 'Evaluari',
  writeReview: 'Scrie o evaluare',
  showAllReviews: 'Vezi toate recenziile',
  hideReviews: 'Ascunde recenziile',
  thankYou: 'Multumim!',
  reviewSubmitted: 'Evaluarea dv a fost trimisa!',
  close: 'Inchide',
  submitReview: 'Trimite evaluarea',
  rateProduct: 'Acorda un rating produsului:',
  writeReviewFor: 'Scrie o evaluare pentru:',
  nickname: 'Nume utilizator:',
  nicknamePlaceholder: 'Numele tau de utilizator',
  nicknameRequired: 'Nume utilizator este obligatoriu',
  nicknameMaxLength: 'Te rugam sa introduci mai putin de 30 caractere.',
  reviewTitle: 'Titlu evaluare:',
  reviewTitlePlaceholder: 'Scrie titlul evaluarii aici',
  reviewTitleRequired: 'Acest camp este obligatoriu',
  reviewTitleMaxLength: 'Te rugam sa introduci mai putin de 50 caractere.',
  reviewText: 'Evaluare:',
  reviewTextPlaceholder: 'Descrie experienta ta cu produsul',
  reviewTextMaxLength: 'Limita este de 1000 caractere.',
  ratingRequired: 'Te rugam sa selectezi un rating!',
} as const
